export default "__VITE_ASSET__d8a6843d__"